import { RowProps } from "./types";

const Row = ({ children, justify, align, onClick = undefined, className = "", style, gap, ...rest }: RowProps) => {
  const spicyStyles = `flex justify-${justify} items-${align} ` + className;
  return (
    <div onClick={onClick} className={spicyStyles} style={{ gap: `${gap}rem`, ...style }} {...rest}>
      {children}
    </div>
  );
};
export default Row;
